// Customer pitches are managed in the editor at /admin. These photos are used when a pitch has none.
export const fallbackImages = {
  heroImage: "/img/hero.jpg",
  closingImage: "/img/river.jpg",
  helmImage: "/img/deck.jpg",
};

export const defaultHeadline = ["Your vessel,", "inspection-ready", "every single day."];

export const contact = {
  email: "marcos@navscora.com",
  phoneDisplay: "047 868 5763",
  phoneHref: "tel:0478685763",
  company: "Navscora™ Pty Ltd",
};
